import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const selectGroup = createAction('[Groups] Select Group', props<{ group: Group }>());

export const selectGroupId = createAction('[Groups] Select Group Id', props<{ groupId: string }>());
